//

import jwtDecode from 'jwt-decode';
//
import axios from './axios';
import axiosInstance from './axioserror';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  // ----------------------------------------------------------------------

  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//     // You can do what ever you want here, like show a notification
//   }, timeLeft);
// };

// ----------------------------------------------------------------------

const clearLocalStorageExceptOne = (keyToKeep) => {
  // Get the value of the key you want to keep
  const valueToKeep = localStorage.getItem(keyToKeep);

  // Clear all localStorage
  localStorage.clear();

  // Restore the value of the key you want to keep
  if (valueToKeep) {
    localStorage.setItem(keyToKeep, valueToKeep);
  }
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    clearLocalStorageExceptOne('errors');

    delete axios.defaults.headers.common.Authorization;
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
